<template>
  <div class="tablet screen">
    <div class="bread_crumbs-4">
      <Link01 />
      <div class="text-4 avenirnextltpro-demi-normal-big-stone-10px">/</div>
      <ActualSection />
    </div>
    <header class="header-3">
      <div class="header_container-3">
        <div class="player_data-3">
          <div class="escudo_equipo-3">
            <img class="logo_equipo-3" v-if="image" :src="image" alt="logo_equipo" />
          </div>
          <div class="info-3">
            <div class="info_container-3">
              <div class="name-3">
                <h1 class="title-1 valign-text-middle">{{ team.team_name }}</h1>
              </div>
              <div
                class="puntos-3"
                v-if="points && seasonType === 0 && ![1784, 1741, 1512, 881].includes(selectedSeason)"
              >
                <div class="nationality-4 valign-text-middle">{{ points }}</div>
                <div class="nationality-5 valign-text-middle avenirnextltpro-medium-white-9px">PTS</div>
              </div>
            </div>
          </div>
        </div>
        <div class="header_info_menu-3">
          <div class="btn-4" :class="value === 4 ? 'active' : ''" @click="onChangeSection(4)">
            <img
              class="icon-clock-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen@2x.png"
              alt="icon-clock"
            />
            <div class="resumen-3 valign-text-middle avenirnextltpro-demi-normal-white-6px">RESUMEN</div>
          </div>
          <div
            class="btn-4"
            v-on:mouseover="isHover = true"
            v-on:mouseleave="isHover = false"
            :class="value === 1 ? 'active' : ''"
            @click="onChangeSection(1)"
          >
            <img
              v-if="!isHover && value != 1"
              class="icon-clock-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_normal@2x.png"
              alt="icon-clock"
            />
            <img v-else class="icon-clock-1" src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_posesion_hover@2x.png" />
            <div class="resumen-3 valign-text-middle avenirnextltpro-demi-normal-white-6px">POSESIÓN</div>
          </div>
          <div class="btn-4" :class="value === 2 ? 'active' : ''" @click="onChangeSection(2)">
            <img
              class="icon-clock-1"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_ofensivo@2x.png"
              alt="icon-clock"
            />
            <div class="resumen-3 valign-text-middle avenirnextltpro-demi-normal-white-6px">OFENSIVO</div>
          </div>

          <div class="btn-4" :class="value === 3 ? 'active' : ''" @click="onChangeSection(3)">
            <img
              class="icn_defensivo"
              src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_defensivo@2x.png"
              alt="icn_defensivo"
            />
            <div class="defensivo-3 valign-text-middle avenirnextltpro-demi-normal-white-6px">DEFENSIVO</div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Link01 from '@/components/Sections/HeaderFigmaTeams/Link01';
import ActualSection from '@/components/Sections/HeaderFigmaTeams/ActualSection';
export default {
  name: 'Tablet',
  components: {
    Link01,
    ActualSection,
  },
  props: {
    points: {
      type: Number,
      required: false,
      default: 0,
    },
    team: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      default: -1,
    },
  },
  watch: {
    value(newId) {
      this.changeSection(newId);
    },
  },
  data() {
    return {
      isHover: false,
      section: 4,
      selectedSeason: 0,
      sections: [
        {
          id: 4,
          title: 'analysis_type.summary',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen_unselected.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn_resumen.svg',
          ],
          selected: false,
        },
        {
          id: 1,
          title: 'analysis_type.possession',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-posesion-white.svg',
          ],
          selected: false,
        },
        {
          id: 2,
          title: 'analysis_type.offensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-ofensive-white.svg',
          ],
          selected: false,
        },
        {
          id: 3,
          title: 'analysis_type.defensive',
          images: [
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-black.svg',
            'https://golstatsimages.blob.core.windows.net/todoelfut/icn-defensive-white.svg',
          ],
          selected: false,
        },
      ],
    };
  },
  computed: {
    ...mapState('filterGeneral', ['seasonType']),
    sectionsIds() {
      return this.sections.map(i => i.id);
    },
    image() {
      if (this.team.logo) {
        return `https://golstatsimages.blob.core.windows.net/teams-150/${this.team.logo.split('/').pop()}`;
      } else {
        return '';
      }
    },
  },
  methods: {
    changeSection(sectionId) {
      if (this.sectionsIds.includes(sectionId)) {
        this.sections.forEach(e => (e.selected = false));
        const section = this.sections.find(s => s.id === sectionId);
        if (section) {
          section.selected = true;
          return true;
        }
      }
      return false;
    },
    onChangeSection(id) {
      this.section = id;
      let result = this.changeSection(id);
      if (result) this.$emit('input', id);
    },
  },
  mounted() {
    this.changeSection(this.value);
  },
  created() {
    const selectedSeason = window.localStorage.getItem('seasonSelected');
    if (selectedSeason) {
      this.selectedSeason = Number(selectedSeason);
    }
  },
};
</script>

<style>
.headerfigmaTeams .active {
  background-color: #23b0ff !important;
}
.headerfigmaTeams .tablet {
  align-items: flex-start;
  border: 1px none;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin-top: -10px;
  position: relative;
}

.headerfigmaTeams .bread_crumbs-4 {
  align-items: center;
  display: flex;
  padding: 0px 0px 0px 4px;
  position: relative;
  width: 100%;
}

.headerfigmaTeams .text-4 {
  letter-spacing: -0.1px;
  line-height: 17px;
  opacity: 0.4;
  position: relative;
  text-align: center;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .header-3 {
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
    180deg,
    rgb(6.85, 91.11, 137.06) 0%,
    rgba(1.63, 68.84, 105.5, 1) 51.8%,
    rgba(1.42, 14.25, 21.25, 1) 100%
  );
  background-color: transparent;
  border-radius: 8.2px;
  display: flex;
  gap: 4.82px;

  margin: 0 auto;
  height: 95px;
  margin-top: 10px;
  mix-blend-mode: normal;
  padding: 4px 12px 6.75px;
  position: relative;
}

.headerfigmaTeams .header_container-3 {
  align-items: flex-start;
  display: flex;
  flex: 1;
  justify-content: space-between;
  position: relative;
}

.headerfigmaTeams .player_data-3 {
  align-items: flex-start;
  display: flex;
  gap: 14px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .escudo_equipo-3 {
  align-items: center;
  display: flex;
  gap: 4.98px;
  height: 65.33px;
  justify-content: flex-end;
  position: relative;
  width: 62.44px;
}

.headerfigmaTeams .logo_equipo-3 {
  height: 63.97px;
  margin-bottom: -1.3px;
  margin-right: -1.98px;
  min-width: 63.97px;
  object-fit: cover;
  position: relative;
}

.headerfigmaTeams .info-3 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4.82px;
  justify-content: center;
  padding: 2px 0px 0px;
  position: relative;
  width: 232px;
}

.headerfigmaTeams .info_container-3 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.headerfigmaTeams .name-3 {
  align-items: flex-start;
  display: flex;
  gap: 10px;
  padding: 3px 0px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .title-1 {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-bold);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 20px;
  margin-top: -1px;
  position: relative;
  text-shadow: 0px 1.93px 1.93px #162b3436;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .puntos-3 {
  align-items: center;
  border: 1px solid;
  border-color: var(--white-2);
  border-radius: 6px;
  display: flex;
  gap: 7px;
  padding: 7px 16px;
  position: relative;
  width: fit-content;
}

.headerfigmaTeams .nationality-4 {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: var(--font-size-xxxl);
  font-weight: 400;
  letter-spacing: -0.16px;
  line-height: 12px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .nationality-5 {
  letter-spacing: -0.09px;
  line-height: 7.7px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .header_info_menu-3 {
  align-items: center;
  align-self: stretch;
  border-radius: 5.79px;
  display: flex;
  gap: 6px;
  justify-content: flex-end;
  position: relative;
  width: 306px;
}

.headerfigmaTeams .btn-4 {
  align-items: center;
  border-radius: 5.3px;
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  padding: 5px 0px;
  position: relative;
  transition: all 0.2s ease;
  box-shadow: 0 0.9px 4.7px 0 rgba(27, 45, 63, 0.14);
  border: solid 0.9px #23b0ff;
}

.headerfigmaTeams .btn-4:hover {
  background-color: #23b0ff;
  cursor: pointer;
}

.headerfigmaTeams .icon-clock-1,
.headerfigmaTeams .icn_radiografia-1 {
  height: 23.63px;
  min-width: 23.63px;
  position: relative;
}

.headerfigmaTeams .resumen-3,
.headerfigmaTeams .defensivo-3 {
  letter-spacing: -0.18px;
  line-height: 4px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .btn_radiografia-1 {
  align-items: center;
  border: 0.48px solid;
  border-color: var(--white);
  border-radius: 5.3px;
  box-shadow: 0px 0.48px 2.41px #1a2d3e24;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  padding: 5px 0px;
  position: relative;
}

.headerfigmaTeams .radiografa-3 {
  color: var(--white);
  font-family: var(--font-family-avenir_next_lt_pro-demi);
  font-size: 5.8px;
  font-weight: 400;
  letter-spacing: -0.17px;
  line-height: 4px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.headerfigmaTeams .icn_defensivo {
  height: 23.82px;
  margin-top: -0.19px;
  min-width: 37.93px;
  position: relative;
}
</style>
